"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _AccountCircle2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _AccountButton = _interopRequireDefault(require("./AccountButton"));
var _RegionalSettingsButton = _interopRequireDefault(require("../components/RegionalSettingsButton"));
var _Media = _interopRequireDefault(require("../components/Media"));
var _context = require("../../../services/auth/context");
var _NavbarLoader2 = _interopRequireDefault(require("./NavbarLoader"));
var _context2 = require("../services/context");
var _events = require("../consts/events");
var _context3 = require("../../../services/log/context");
var _jsxRuntime = require("react/jsx-runtime");
var _AccountCircle, _FormattedMessage, _NavbarLoader, _FormattedMessage2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AuthComponent = ({
  isLoggedIn,
  togglePanel,
  onOpenModal
}) => {
  const {
    isSignInShown
  } = (0, _context2.useNavConfig)();
  if (!isSignInShown) {
    return null;
  }
  return isLoggedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountButton.default, {
    togglePanel: togglePanel
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
    onClick: () => onOpenModal(),
    iconLeft: _AccountCircle || (_AccountCircle = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountCircle2.default, {
      ariaHidden: true
    })),
    compact: true,
    type: "secondary",
    dataTest: "TopNav-SingInButton",
    children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "navbar.header.sign_in"
    }))
  });
};
const NavRightLinks = ({
  modalId,
  brandLanguage,
  onOpenHelp,
  togglePanel
}) => {
  const {
    isRegionalSettingsShown,
    isHelpShown
  } = (0, _context2.useNavConfig)();
  const {
    state,
    onOpenModal,
    auth
  } = (0, _context.useAuth)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context3.useLog)();
  const isAuthResolved = state === "resolved";
  const isLoggedIn = (auth === null || auth === void 0 ? void 0 : auth.type) === "user";
  if (!isAuthResolved) {
    return _NavbarLoader || (_NavbarLoader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavbarLoader2.default, {}));
  }
  const handleHelpButtonClick = () => {
    onOpenHelp();
    log(_events.HELP_BUTTON_CLICKED, {});
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
      inline: true,
      align: "center",
      justify: "end",
      spacing: "none",
      largeMobile: {
        spacing: "medium"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Media.default, {
        greaterThanOrEqual: "tablet",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          inline: true,
          align: "center",
          justify: "end",
          spacing: "large",
          children: [isRegionalSettingsShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegionalSettingsButton.default, {
            modalId: modalId,
            brandLanguage: brandLanguage,
            simple: true,
            render: ({
              text,
              countryFlag,
              openModal
            }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
              compact: true,
              dataTest: "TopNav-RegionalSettingsButton",
              ariaControls: "Regional settings switcher",
              iconLeft: countryFlag,
              rel: "nofollow",
              title: "Switch Regional settings",
              type: "secondary",
              onClick: openModal,
              children: text
            })
          }), isHelpShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
            compact: true,
            ariaControls: intl.formatMessage({
              id: "navbar.header.help_and_support"
            }),
            type: "secondary",
            dataTest: "TopNav-HelpButton",
            onClick: handleHelpButtonClick,
            children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.header.help_and_support"
            }))
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthComponent, {
      isLoggedIn: isLoggedIn,
      togglePanel: togglePanel,
      onOpenModal: onOpenModal
    })]
  });
};
var _default = NavRightLinks;
exports.default = _default;